import React , {useEffect, useState} from 'react'
import { styled } from '@mui/system';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ChatIcon from '@mui/icons-material/Chat';


const Container = styled('div')((props) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  visibility : props.visibility,
  opacity : props.opacity,
  zIndex : '3',
  transition: 'all 1s ease',
}))

const Nav = styled('div')({
  display: 'flex',
  background : 'rgba(0,0,0,0.3)',
  backdropFilter : 'blur(10px)',
  borderRadius : '50px',
  overflow : 'hidden',
  position : 'fixed',
  bottom : '30px',
  padding : '0px 20px 0px 20px',
  zIndex : '3',
})

const NavIcon = styled('div')((props)=> ({
  height: '40px',
  width: '40px',
  borderRadius: '50%',
  color: props.className === props.active ? 'var(--color-white)' :'var(--color-light)',
  backgroundColor: props.className === props.active ? 'rgba(0,0,0,0.5)' : 'transparent',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '5px',
  '&:hover': {
    color: 'var(--color-white)',
    backgroundColor: 'rgba(0,0,0,0.5)',
    transform: 'scale(1.1)',
    transition: 'all 0.5s ease',
  },
}))

function Navbar() {
  const [visibilityNavbar,setVisibilityNavbar ] = useState('hidden')
  const [opacityNavbar, setOpacityNavbar] = useState('0')
  const [activeNavbar, setActiveNavbar] = useState('header')

  useEffect(() => {
    setTimeout(function() {
      setVisibilityNavbar('visible')
      setOpacityNavbar('1')
    }, 1500)
  }, [])



  return (
    <Container visibility={visibilityNavbar} opacity={opacityNavbar}> 
      <Nav>
        <a href='#header'>
          <NavIcon className='header' active={activeNavbar} onClick={() => setActiveNavbar('header')} >
            <HomeIcon />
          </NavIcon>
        </a>
        <a href='#about'>
          <NavIcon className='about' active={activeNavbar} onClick={() => setActiveNavbar('about')}>
            <PersonIcon />
          </NavIcon>
        </a>
        <a href='#services'>
          <NavIcon className='services' active={activeNavbar} onClick={() => setActiveNavbar('services')}>
            <MiscellaneousServicesIcon />
          </NavIcon>
        </a>
        <a href='#portfolio'>
          <NavIcon className='portfolio' active={activeNavbar} onClick={() => setActiveNavbar('portfolio')}>
            <AutoStoriesIcon />
          </NavIcon>
        </a>
        <a href='#contact'>
          <NavIcon className='contact' active={activeNavbar} onClick={() => setActiveNavbar('contact')}>
            <ChatIcon />
          </NavIcon>
        </a>
      </Nav>
    </Container>
  )
}

export default Navbar